import {LinearFilter, RepeatWrapping, Texture, Vector3} from "three";
import {MarkerModel} from "features/apartmentViewer/ApartmentViewer/models/MarkerModel";
import {DepthManager} from "features/apartmentViewer/ApartmentViewer/services/DepthManager";
import {HDRTextureProcessor} from "../services/HDRTextureProcessor";


export class PanoramaModel {
    public position: Vector3;
    public texture: Texture | null;
    public marker: MarkerModel | undefined;

    constructor(
        public depthManager: DepthManager,
        private HDRTextureProcessor: HDRTextureProcessor
    ) {
        this.position = new Vector3();
        this.texture = new Texture();
    }

    async loadCamera(marker: MarkerModel) {
        this.marker = marker;
        this.position.copy(marker.position);

        this.texture = await this.HDRTextureProcessor.loadPanoramaTexture(marker.id);

        if(this.texture) {
            this.initTexture(this.texture);
        }

        this.depthManager.setupDepth(this.texture);
    }

    private initTexture(texture: Texture): void {
        texture.wrapS = RepeatWrapping;
        texture.wrapT = RepeatWrapping;
        texture.minFilter = LinearFilter;
        texture.magFilter = LinearFilter;
    }

    dispose() {
        this.texture = null
    }
}
